export default {
  // 반경 m이내의 위도차(degree)
  LatitudeInDifference: (diff) => {
    // 지구반지름
    const earth = 6371000 // 단위m
    return (diff * 360.0) / (2 * Math.PI * earth)
  },
  // 반경 m이내의 경도차(degree)
  LongitudeInDifference: (_latitude, diff) => {
    // 지구반지름
    const earth = 6371000 // 단위m
    // let ddd = Math.cos(0)
    // let ddf = Math.cos(Math.toRadians(_latitude))
    return (diff * 360.0) / (2 * Math.PI * earth * Math.cos(_latitude * (Math.PI / 180)))
  },
  isMobile: () => {
    const filter = 'win16|win32|win64|mac|macintel'
    if (navigator.platform) {
      if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
        return true
      }
    }
    return false
  },
  isiPhone: () => {
    console.log('isiphone:' + navigator.userAgent)
    return (/iPhone|iPad|iPod/i.test(navigator.userAgent))
  },
  move: (url) => {
    window.location.href = url
  },
  copyToClipboard: (val) => {
    var t = document.createElement('textarea')
    document.body.appendChild(t)
    t.value = val
    t.select()
    document.execCommand('copy')
    document.body.removeChild(t)
  },
  // 로컬 테스트를 겸하기위한
  getStaticUrl: () => {
    if (document.location.hostname === '127.0.0.1') { // 로컬 테스트용
      return `http://127.0.0.1:8080/static`
    }
    return `${document.location.origin}/rep/static`
  },
  getRestUrl: () => {
    if (document.location.hostname === '127.0.0.1') { // 로컬 테스트용
      return `http://127.0.0.1/rep/api`
    }
    return `${document.location.origin}/rep/api`
  },
  getBaseUrl: () => {
    if (document.location.hostname === '127.0.0.1') { // 로컬 테스트용
      return `http://127.0.0.1`
    }
    return `${document.location.origin}`
  },
  getAxiosConfig: (header) => {
    if (document.location.hostname === '127.0.0.1') { // 로컬 테스트용
      return { crossDomain: true, withCredentials: true, headers: header }
    }
    return { headers: header }
  },
  // 로컬 테스트를 겸하기위한
  // 맵 마커 컨트롤을 위한 lat,lng 기반 아이디
  getMarkerId: (lat, lng) => {
    lat = String(lat).replace('.', '')
    lng = String(lng).replace('.', '')
    return `id${lat.substring(0, 8)}${lng.substring(0, 8)}`
  }
}



// WEBPACK FOOTER //
// ./src/utile/utile.js